var React = require('react');

function Tourn (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M5 7.5h-.833c-.664 0-1.3-.263-1.768-.732-.47-.47-.732-1.105-.732-1.768V.833H5M15 7.5h.833c.663 0 1.3-.263 1.768-.732.469-.47.732-1.105.732-1.768V.833H15M10 15.833V12.5M10 12.5c-1.326 0-2.598-.527-3.536-1.464C5.527 10.098 5 8.826 5 7.5V.833h10V7.5c0 1.326-.527 2.598-1.464 3.536-.938.937-2.21 1.464-3.536 1.464zM15 19.167H5c0-.884.351-1.732.976-2.357.625-.625 1.473-.977 2.357-.977h3.334c.884 0 1.732.351 2.357.977.625.625.976 1.473.976 2.357z"}));
}

Tourn.defaultProps = {"width":"20","height":"20","fill":"none","viewBox":"0 0 20 20","stroke":"#737680"};

module.exports = Tourn;

Tourn.default = Tourn;
